import { string } from 'yup';

export const emailSchema = string()
  .typeError('O e-mail precisa ser um campo de texto')
  .required('Informe um e-mail')
  .email('E-mail inválido');
